import React from 'react'

export default function QuestionnaireBeaconbackdrop() {
  return (
    <div
      style={{ top: '-330px', left: '-131px', width: 847, height: 700, pointerEvents: 'none', opacity: '0.15' }}
      className="questionnaire-beacon-wrapper-backdrop dome-absolute"
    >
      <div
        style={{
          width: '308px',
          height: '308px',
          position: 'absolute',
          right: 0,
          bottom: '173px',
          borderRadius: '308px',
          background: 'radial-gradient(50% 50% at 50% 50%, rgba(0, 145, 163, 0.30) 0%, rgba(217, 217, 217, 0.00) 100%)',
        }}
      ></div>
      <div
        style={{
          width: '308px',
          height: '308px',
          position: 'absolute',
          right: '105px',
          bottom: '185px',
          borderRadius: '308px',
          background:
            'radial-gradient(50% 50% at 50% 50%, rgba(168, 203, 143, 0.53) 0%, rgba(217, 217, 217, 0.00) 100%)',
        }}
      ></div>
      <div
        style={{
          width: '380px',
          height: '700px',
          position: 'absolute',
          borderRadius: '700px',
          background: 'radial-gradient(50% 50% at 50% 50%, rgba(0, 145, 163, 0.30) 0%, rgba(217, 217, 217, 0.00) 100%)',
        }}
      ></div>
      <div
        style={{
          width: '380px',
          height: '654px',
          position: 'absolute',
          left: 68,
          bottom: 0,
          borderRadius: '654px',
          background:
            'radial-gradient(50% 50% at 50% 50%, rgba(168, 203, 143, 0.45) 0%, rgba(217, 217, 217, 0.00) 100%)',
        }}
      ></div>
    </div>
  )
}
